import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "header" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "step-name" };
import { useCalc } from './calc';
import Step1 from "./Step1.vue";
import Step2 from "./Step2.vue";
import Step3 from "./Step3.vue";
import Step4 from "./Step4.vue";
import Step5 from "./Step5.vue";
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CalculationFormApp',
    props: {
        max_pay: Number,
        meal_cost_special: Number,
        domestic_cost_single: Number,
        special_cost_single: Number,
        domestic_cost_couple: Number,
        special_cost_couple: Number,
        fee_text: Object,
        notice_text: String,
    },
    setup(__props) {
        const props = __props;
        const el = ref();
        const calc = useCalc(props, el);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass({ [`direction--${_unref(calc).movingForward.value ? 'right' : 'left'}`]: true }),
                ref_key: "el",
                ref: el
            }, [
                _createElementVNode("header", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(calc).StepList, (step) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: step,
                            class: "header-step",
                            onClick: ($event) => (_unref(calc).gotoStep(step))
                        }, [
                            _createElementVNode("span", {
                                class: _normalizeClass(["step-number", {
                                        'is--filled': _unref(calc).StepNumbers[step] <= _unref(calc).StepNumbers[_unref(calc).activeStep.value],
                                        'is--active': _unref(calc).StepNumbers[step] === _unref(calc).StepNumbers[_unref(calc).activeStep.value]
                                    }])
                            }, _toDisplayString(_unref(calc).StepNumbers[step]), 3),
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(calc).StepLabels[step]), 1)
                        ], 8, _hoisted_2));
                    }), 128))
                ]),
                _createVNode(_Transition, { name: "slide" }, {
                    default: _withCtx(() => [
                        (_unref(calc).activeStep.value === _unref(calc).Step.AgeAndMarital)
                            ? (_openBlock(), _createBlock(Step1, {
                                key: 0,
                                calc: _unref(calc),
                                props: props
                            }, null, 8, ["calc", "props"]))
                            : (_unref(calc).activeStep.value === _unref(calc).Step.TypeOfService)
                                ? (_openBlock(), _createBlock(Step2, {
                                    key: 1,
                                    calc: _unref(calc),
                                    props: props
                                }, null, 8, ["calc", "props"]))
                                : (_unref(calc).activeStep.value === _unref(calc).Step.Accommodation)
                                    ? (_openBlock(), _createBlock(Step3, {
                                        key: 2,
                                        calc: _unref(calc),
                                        props: props
                                    }, null, 8, ["calc", "props"]))
                                    : (_unref(calc).activeStep.value === _unref(calc).Step.IncomeAndExpenditure)
                                        ? (_openBlock(), _createBlock(Step4, {
                                            key: 3,
                                            calc: _unref(calc),
                                            props: props
                                        }, null, 8, ["calc", "props"]))
                                        : (_unref(calc).activeStep.value === _unref(calc).Step.Calculation)
                                            ? (_openBlock(), _createBlock(Step5, {
                                                key: 4,
                                                calc: _unref(calc),
                                                props: props
                                            }, null, 8, ["calc", "props"]))
                                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 2));
        };
    }
});
